import React, { useState, useRef, useEffect } from 'react';

/**
 * NoteInput Component
 * 
 * A small modal/popover for entering a version note before upload.
 */
const NoteInput = ({
  filename,
  onConfirm,
  onCancel,
}) => {
  const [note, setNote] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm(note.trim() || null);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      onCancel();
    }
  };

  return (
    <div className="note-input-overlay" onClick={onCancel}>
      <div className="note-input" onClick={e => e.stopPropagation()}>
        <div className="note-input__header">
          <span className="note-input__title">Add version note</span>
          <span className="note-input__filename">{filename}</span>
        </div>
        
        <form onSubmit={handleSubmit}>
          <input
            ref={inputRef}
            type="text"
            className="note-input__field"
            placeholder="e.g., Fixed typo in section 3"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            onKeyDown={handleKeyDown}
            maxLength={200}
          />
          
          <div className="note-input__actions">
            <button 
              type="button" 
              className="note-input__btn note-input__btn--skip"
              onClick={() => onConfirm(null)}
            >
              Skip
            </button>
            <button 
              type="submit" 
              className="note-input__btn note-input__btn--confirm"
            >
              Upload
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NoteInput;
